import { Component, h, Element, State, Host, Prop } from '@stencil/core';

@Component({
  tag: 'zpr-carousel-vertical'
})
export class ZprCarouselVertical {

  private imageContainer:HTMLElement;

  @Element() host:HTMLElement;
  @State() renderAsCarousel: boolean = false;
  @State() currentImage: HTMLImageElement | HTMLElement;
  @State() nextImage: HTMLImageElement | HTMLElement;
  @Prop() isImageContainerFixed?: boolean;

  componentWillLoad(){
    this.adjustForMobile(true)
    window.addEventListener('resize',()=>{
      this.adjustForMobile()
    })
  }

  componentDidLoad(){
    const currentImage = this.host.querySelector("zpr-carousel-vertical-item[open] img") as HTMLImageElement || this.host.querySelector("zpr-carousel-vertical-item[open] [slot='image']") as HTMLElement

    this.currentImage = currentImage

    this.currentImage.removeAttribute('hidden')

    if(this.imageContainer){
      this.imageContainer.append(this.currentImage);
    }

    this.host.addEventListener('onOpen', (ev:CustomEvent) =>{
      if (this.isImageContainerFixed) {
        return
      }
      const nextImage = ev.detail.image;
      this.openSlide(nextImage)
    })

  }

  openSlide(image:HTMLImageElement | HTMLElement){
    const nextImage = image;
    this.nextImage = nextImage;
    this.nextImage.className = 'slideFromBottom';


    this.currentImage.className = 'slideToTop';

    setTimeout(()=>{
      const slide = this.host.querySelector('.slideToTop')
      if(slide) slide.className = 'hide-slide'
      this.currentImage = nextImage
      this.currentImage.removeAttribute('hidden')
      this.currentImage.className = 'slideFromBottom'
      this.imageContainer.innerHTML = ''
      this.imageContainer.append(this.currentImage)
      setTimeout(()=>{
        this.currentImage.className = ''
      }, 300)
    }, 300)
  }

  adjustForMobile(initial:boolean = false){
    this.renderAsCarousel = window.innerWidth >= 1024;

    if(initial) return;

    if(this.renderAsCarousel){
      this.openSlide(this.currentImage)
    }
  }

  render(){
    return (
      <Host>
        {
        this.renderAsCarousel ? (
          <div class={{
            "image-container":true,
            "is-fixed": this.isImageContainerFixed
            }}>
            <div class="image-slides-container"
            ref={el => this.imageContainer = el as HTMLElement}>
            </div>
          </div>
        ):(<span></span>)}

        <div class={{
          "text-container":this.renderAsCarousel
        }}>
           <slot></slot>
        </div>
      </Host>
    )
  }

}
